import { ComponentBase } from "./ComponentBase.js";
import { template } from '../utils/TemplateParser';

import loadingGif from '../../images/loading-big.gif';

export class LoadingIndicator extends ComponentBase {
    constructor() {
        super();
        this.render();
    }

    template() {
        return template`
            <span class='loading'><img src="${loadingGif}">Loading...</span>
        `;
    }
}

